import { ReactNode, useMemo } from "react";
import { ConfigProvider as AntdConfigProvider } from "antd";
import ptBR from "antd/locale/pt_BR";
import { StyleSheetManager } from "styled-components";
import ThemeProvider from "@styles/ThemeProvider";
import { GlobalStyles } from "@styles/GlobalStyles";
import { createCustomTheme } from "@styles/theme";
import { useClientSettings } from "@hooks/useClientSettings";

const returnTrue = () => true;

/**
 * ClientTheme composition and theme providers setup from third party such as antd/styled-components.
 */
export const StyleProvider = ({ children }: { children: ReactNode }) => {
  const client = useClientSettings();
  const customTheme = useMemo(() => createCustomTheme(client), [client]);

  return (
    <StyleSheetManager shouldForwardProp={returnTrue}>
      <AntdConfigProvider locale={ptBR} theme={customTheme}>
        <ThemeProvider>
          <>{children}</>
          <GlobalStyles />
        </ThemeProvider>
      </AntdConfigProvider>
    </StyleSheetManager>
  );
};
